import { api, wire, LightningElement } from "lwc";
import { Config, Image } from "./types";
import {
  ResizeObserverAdapter,
  ResizeObserverEntry,
} from "common/resizeObserverAdapter";

type Size = "small" | "medium" | "large";

const widthBreakpoints: Record<Size, number> = {
  small: 400,
  medium: 800,
  large: Infinity,
};

function isDisplayableImage(image: Image | undefined) {
  return !!(image && image.src);
}

export default class extends LightningElement {
  @api config: Config = {};

  size: Size = "large";

  @wire(ResizeObserverAdapter, {
    template: "$template",
  })
  private onResize(entry: ResizeObserverEntry) {
    const width = entry.contentRect.width;
    if (width < widthBreakpoints.small) {
      this.size = "small";
    } else if (width < widthBreakpoints.medium) {
      this.size = "medium";
    } else {
      this.size = "large";
    }
  }

  private get className() {
    return `promo size--${this.size}`;
  }

  private get styles() {
    return {
      container: this.getContainerStyles(),
      content: this.getContentStyles(),
    };
  }

  private getContainerStyles() {
    const background = this.config.background;
    return background ? `background-color: ${background.color}` : "";
  }

  private get hasMainImage() {
    return isDisplayableImage(this.config.img);
  }

  private get content() {
    return this.config.content || {};
  }

  private getContentStyles() {
    const color = this.content.color;
    return color ? `color: ${color}` : "";
  }

  private get hasContentImage() {
    return isDisplayableImage(this.content.img);
  }

  private get cta() {
    return this.config.cta;
  }
}
